import React, { useState, useEffect } from "react";
import axios from "axios";
import styled from "styled-components";
import { FiMail } from "react-icons/fi";
import { BsCheckLg, BsArrowUp, BsPeople } from "react-icons/bs";
import { HiOutlineCurrencyRupee } from "react-icons/hi";
import laptop from "../assets/laptop.png";
import line from "../assets/line.png";
import dot1 from "../assets/dot1.png";
import dot2 from "../assets/dot2.png";

const Hero = () => {
  const [email, setEmail] = useState("");
  const token = {
    Username: "nmskaarmm2023",
    Password: "mm@2023",
  };
  const options = {
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      Authorization: `Bearer ${token}`,
    },
  };
  const postNewsletter = async () => {
    try {
      const res = await axios.post("/api/data/Addsubscribe", email, options);
      console.log(res);
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <HeroContainer>
      <BorderHero>
        <div className="border"></div>
        <h4>helping business</h4>
      </BorderHero>
      <h3>Money Manager Tool to Boost Your Business</h3>
      <p>
        Briefly explain how the solution's works, what's unique about it and{" "}
        <br />
        what results will your users get from using it
      </p>
      <InputContainer>
        <FiMail className="icon" />
        <input
          type="text"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          placeholder="Enter your mail"
        />
        <div className="btnStart" onClick={postNewsletter}>
          Start for free
        </div>
      </InputContainer>
      <FeatureList>
        <li>
          <div>
            <BsCheckLg className="check" />
          </div>
          Free 14-day Demo
        </li>
        <li>
          <div>
            <BsCheckLg className="check" />
          </div>
          No credit card needed
        </li>
        <li>
          <div>
            <BsCheckLg className="check" />
          </div>
          No Setup
        </li>
      </FeatureList>
      <Laptop src={laptop} alt="" />
      <Line src={line} alt="" />
      <Revenue>
        <div className="share">
          <div>
            <HiOutlineCurrencyRupee className="shareIco" />
          </div>
          <div>
            <p>+48.50%</p>
          </div>
          <div>
            <BsArrowUp className="iconBs" />
          </div>
        </div>
        <div>
          <h3>₹36,845.00</h3>
          <p>Total Revenue</p>
        </div>
      </Revenue>
      <Customer>
        <div className="share">
          <div>
            <HiOutlineCurrencyRupee className="shareIco" />
          </div>
          <div>
            <p>+38.80%</p>
          </div>
          <div>
            <BsArrowUp className="iconBs" />
          </div>
        </div>
        <div>
          <h3>₹36,845.00</h3>
          <p>Total Customer</p>
        </div>
      </Customer>
      <Dot1 src={dot1} alt="" />
      <Dot2 src={dot2} alt="" />
      <Dot3 src={dot2} alt="" />
      <Dot4 src={dot1} alt="" />
    </HeroContainer>
  );
};

export default Hero;

const HeroContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 4rem calc((100vw - 1200px) / 2);
  position: relative;

  h3 {
    font-size: 55px;
    font-weight: 600;
    color: #20204f;
    text-align: center;
    line-height: 68px;
    width: 60%;
    margin-top: -10px;
  }
  p {
    text-align: center;
    color: #535353;
    margin-top: 15px;
    font-weight: 500;
  }
  @media only screen and (max-width: 991px) {
    h3 {
      font-size: 30px;
      font-weight: 600;
      color: #20204f;
      margin-top: 5px;
      text-align: center;
      line-height: 40px;
      width: 100%;
    }
    p {
      text-align: center;
      color: #535353;
      margin-top: 15px;
      font-weight: 500;
      width: 95%;
    }
  }
`;

const BorderHero = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  .border {
    background-color: #3aaa35;
    height: 3px;
    width: 45px;
  }
  h4 {
    text-transform: uppercase;
    font-weight: 500;
    font-size: 18px;
    margin-left: 10px;
    color: #3aaa35;
  }
`;

const InputContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  padding: 7px;
  margin-top: 22px;
  border-radius: 30px;
  position: relative;

  input {
    padding: 10px 20px;
    width: 310px;
    font-weight: 500;
    font-size: 14px;
    border: none;
    outline: none;
    padding-left: 47px;
    color: #20204f;
    font-weight: 500;
  }
  .btnStart {
    padding: 10px 20px;
    background-color: #20204f;
    color: #fff;
    border-radius: 25px;
    cursor: pointer;
  }
  .icon {
    position: absolute;
    left: 5%;
    color: grey;
    font-size: 18px;
  }
  @media only screen and (max-width: 991px) {
    margin: 0px 15px;
    margin-top: 22px;
    input {
      padding: 10px 20px;
      width: 100%;
      font-weight: 500;
      font-size: 14px;
      padding-left: 47px;
    }
    .btnStart {
      padding: 10px 10px;
      cursor: pointer;
      width: 62%;
      text-align: center;
    }
  }
  @media only screen and (max-width: 360px) {
    .btnStart {
      padding: 10px 10px;
      cursor: pointer;
      width: 75%;
      text-align: center;
    }
  }
`;

const FeatureList = styled.ul`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  list-style: none;
  li {
    color: grey;
    margin: 0px 10px;
    font-size: 15px;
    display: flex;

    div {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #9eff9e;
      height: 25px;
      width: 25px;
      border-radius: 50%;
      margin-right: 7px;

      .check {
        font-size: 16px;
        color: green;
      }
    }
  }
  @media only screen and (max-width: 991px) {
    flex-direction: column;
    li {
      margin-bottom: 1rem;
    }
  }
`;

const Laptop = styled.img`
  height: 500px;
  margin-top: 50px;
  object-fit: cover;
  z-index: 1000000;

  @media only screen and (max-width: 991px) {
    height: 190px;
    margin-top: 0px;
  }
`;

const Line = styled.img`
  position: absolute;
  top: 37%;
  width: 100%;

  @media only screen and (max-width: 991px) {
    top: 70%;
  }
`;

const Revenue = styled.div`
  position: absolute;
  top: 50%;
  left: 10%;
  transform: translateY(-50%);
  background-color: #fff;
  border-radius: 15px;
  padding: 15px;

  .share {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0px;
    .shareIco {
      background-color: #9eff9e;
      height: 25px;
      width: 25px;
      color: #3aaa35;
      border-radius: 8px;
    }
    p {
      margin-top: -15px;
    }
    .iconBs {
      background-color: #ffedfe;
      height: 20px;
      width: 20px;
      color: #ff8686;
      border-radius: 8px;
      font-size: 18px;
    }
  }
  div {
    margin-bottom: -10px;
    h3 {
      text-align: left;
      font-size: 22px;
      margin-bottom: -35px;
    }
    p {
      text-align: left;
      font-size: 15px;
      padding-top: 0px !important;
      margin-bottom: -5px;
    }
  }
  @media only screen and (max-width: 991px) {
    display: none;
  }
`;

const Customer = styled.div`
  position: absolute;
  top: 80%;
  right: 7%;
  transform: translateY(-20%);
  background-color: #fff;
  border-radius: 15px;
  padding: 15px;

  .share {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
    .shareIco {
      background-color: #9eff9e;
      height: 25px;
      width: 25px;
      color: #3aaa35;
      border-radius: 8px;
    }
    p {
      margin-top: -15px;
    }
    .iconBs {
      background-color: #ffedfe;
      height: 20px;
      width: 20px;
      color: #ff8686;
      border-radius: 8px;
      font-size: 18px;
    }
  }

  div {
    margin-bottom: -15px;
    h3 {
      text-align: left;
      font-size: 22px;
      margin-bottom: -35px;
    }
    p {
      text-align: left;
      font-size: 15px;
      padding-top: 0px !important;
      margin-bottom: -5px;
    }
  }
  @media only screen and (max-width: 991px) {
    display: none;
  }
`;

const Dot1 = styled.img`
  position: absolute;
  top: 56%;
  left: 25%;
  transform: translateX(-75%);
  width: 15px;
  height: 15px;

  @media only screen and (max-width: 991px) {
    display: none;
  }
`;

const Dot2 = styled.img`
  position: absolute;
  top: 75%;
  left: 15%;
  transform: translateX(-75%);
  width: 10px;
  height: 10px;
`;

const Dot3 = styled.img`
  position: absolute;
  top: 70%;
  right: 10%;
  transform: translateX(-90%);
  width: 15px;
  height: 15px;
`;

const Dot4 = styled.img`
  position: absolute;
  top: 80%;
  right: 20%;
  transform: translateX(-80%);
  width: 10px;
  height: 10px;
`;
